import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText } from '@mui/material';
import { ENV_DECLARONS, isBrandActive } from '../../config/environment.config';
import { useTailwindBrand } from '../shared';
import { getBrandConfig } from '../../config/brandConfig';

interface FormCheckboxProps {
  label: string;
  checked: boolean;
  error?: string;
  onChange: () => void;
  href?: string;
  required?: boolean;
  classLabel?: string
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  label,
  checked,
  error,
  onChange,
  href,
  required = true,
  classLabel
}) => {
  const { classes } = useTailwindBrand();
  const config = getBrandConfig();

  return (
    <div className="flex flex-col items-start w-full pl-2">
      <FormControl
        required
        error={error ? true : false}
      // component="fieldset"
      // sx={{ m: 3 }}
      // variant="standard"
      >
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox sx={{
                color: error ? config.colors.error : (classLabel ? config.colors.text : config.colors.primary),
                '&.Mui-checked': { color: config.colors.primary },
                '&.MuiCheckbox-root': { padding: 0, paddingRight: 1 },
              }}
                checked={checked}
                onChange={onChange}
              />
            }
            required={required}
            label={href ? (
              <a
                target="_blank"
                href={href}
                className={`${error && !checked ? classes.error : (classLabel ?? classes.primaryText)} ${classes.fontFamily} underline hover:opacity-80 transition-opacity`}
                rel="noreferrer"
              >
                {label}
              </a>
            ) : (
              <span
                className={`${error && !checked ? classes.error : (classLabel ?? classes.primaryText)} ${classes.fontFamily}`}
              >
                {label}
              </span>
            )}
          />
        </FormGroup>
        <FormHelperText className={`italic /font-semibold ${classes.error} ${classes.fontFamily}`}> {error && !checked && (error)}</FormHelperText>
      </FormControl>
    </div>
  );
};


export default FormCheckbox



